
window.inIframe = function () {
	try {
		return window.self !== window.top;
	} catch (e) {
		return true;
	}
}

window.readCookie = function (name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ')
			c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0)
			return c.substring(nameEQ.length, c.length);
	}
	return null;
}

if (window.inIframe() && window.readCookie("_DISABLE_ENGAGEBAY_BRANDING")) {

	try {
		// Remove engagebay brand name
		setTimeout(function() {
			$('.brand-text-name').text('This');
		}, 500)
	} catch (e) {
	}

	var head = document.getElementsByTagName('head')[0];
	var link = document.createElement('link');
	link.rel = 'stylesheet';
	link.type = 'text/css';
	link.href = window.JS_LEGACY_CLOUD_RESOURCE_PATH + '/assets/css/iframe.css';
	link.media = 'all';
	head.appendChild(link);
}
